import PropTypes from "prop-types";
import LegalBar from "../LegalBar";
import InternationalSites from "./InternationalSites";
import styles from "./Footer.css";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout";
import AppDownload from "../AppDownload";
import MainContent from "./MainContent";

const Footer = ({ isAccordion, ...rest }) => (
  <footer className={styles.container} data-testid="footer">
    {isAccordion ? (
      <MainContent isAccordion={true} {...rest} viewable={[SMALL_VIEWPORT]} />
    ) : (
      <>
        <InternationalSites viewable={[SMALL_VIEWPORT]} />
        <MainContent
          isAccordion={false}
          {...rest}
          viewable={[MEDIUM_VIEWPORT, LARGE_VIEWPORT]}
        />
        <AppDownload
          viewable={[SMALL_VIEWPORT]}
          ctaRef={"global footer|appDownload component|our apps"}
        />
        <LegalBar />
      </>
    )}
  </footer>
);

Footer.propTypes = {
  isAccordion: PropTypes.bool
};

export default Footer;
